import PatientHeader from "./PatientHeader";

export default PatientHeader;
